<template lang="html">
  <div class="real-estate">
    <div v-if="translationsLoaded">
      <masterdata-ui
        :include-tree="true" :columns="columns"
        :load-items-action-url="loadItemsActionUrl" :create-item-action-url="createItemActionUrl"
        :update-item-action-url="updateItemActionUrl" :grid-title="SR_RealEstate.FacilityPartType"
        :modal-title-add="SR_RealEstate.AddFacilityPartType"
        :modal-title-edit="SR_RealEstate.EditFacilityPartType" :setup-modal-content="setupModalContent"
        :build-object-for-request="buildObjectForRequest"
        :global-and-tenant-items="true" @entityChanged="updateEntity"
      />
    </div>
  </div>
</template>

<script lang="js">
import masterdataUi from './masterdata-ui'
import makeResourceMixin from 'src/vue/mixins/make-resource-mixin'
import newGuid from 'src/js/helpers/new-guid'

const resources = {
  SR_RealEstate: 'Areas.RealEstate.SR_RealEstate'
}

export default {
  components: {
    masterdataUi
  },
  mixins: [makeResourceMixin(resources)],

  data () {
    return {
      loadItemsActionUrl: '/RealEstate/MasterDataFacilityPartType/GetFacilityPartTypes',
      createItemActionUrl: '/RealEstate/MasterDataFacilityPartType/Create',
      updateItemActionUrl: '/RealEstate/MasterDataFacilityPartType/Update',
      entityId: null,
      translationsLoaded: false
    }
  },

  computed: {
    columns () {
      return [
        {
          localizedTitle: this.SR_RealEstate['FacilityPartType'],
          typeName: 'String',
          propertyName: 'name'
        },
        {
          localizedTitle: this.SR_RealEstate['IsSystem'],
          typeName: 'Boolean',
          propertyName: 'isSystem'
        },
        {
          localizedTitle: 'UID',
          typeName: 'String',
          propertyName: 'uid',
          isIdColumn: true,
          invisible: true
        },
        {
          localizedTitle: 'fkDataOwner',
          typeName: 'String',
          propertyName: 'fkDataOwner',
          isIdColumn: false,
          invisible: true
        }
      ]
    }

  },

  methods: {
    setupModalContent (data = {uid: newGuid(), name: ''}) {
      return [
        {propertyName: 'uid', value: data.uid, label: '', required: false, editable: false},
        {propertyName: 'name', value: data.name, label: this.SR_RealEstate.FacilityPartType, required: true, editable: true}
      ]
    },

    updateEntity (entityId) {
      this.entityId = entityId
    },

    buildObjectForRequest (data) {
      return {
        uid: data[0].value,
        name: data[1].value,
        fkDataOwner: data.fkDataOwner
      }
    }

  },

  created () {
    this.$store.dispatch('i18n/preloadTranslations', [
      'Areas.RealEstate.SR_RealEstate'
    ])
      .then(() => {
        this.translationsLoaded = true
      })
  }
}
</script>

<style lang="scss" scoped>
</style>
